// extracted by mini-css-extract-plugin
export default {"image":"background_image__ddnKw","background":"background_background__Q6oc-","content":"background_content__4YVBn"};